module.exports = "<div *ngIf=\"_isShowContent\" class=\"mb-2\">\n  <ng-content></ng-content>\n</div>\n"